<template>
  <div v-if="this.loading != true && this.insurance.length > 0">
    <v-data-iterator
      :items="membership"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
    >
      <template v-slot:header>
        <v-toolbar dark flat height="60" :hidden="hideToolbar" color="secondary" class="mb-1">
          <template>
            <v-select
              v-model="sortBy"
              flat
              dense
              solo-inverted
              hide-details
              :items="keys"
              prepend-inner-icon="mdi-sort-variant"
              label="Sort by"
            ></v-select>
            <v-spacer></v-spacer>
            <v-btn-toggle background-color="rgba(0,0,0,0)" v-model="sortDesc" mandatory>
              <v-btn color="primary" height="40" :value="false">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn color="primary" height="40" :value="true">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-toolbar>
      </template>

      <template v-slot:no-data>
        <v-row class="px-4">
          <v-col class="text-center">
            No data available
          </v-col>
        </v-row>
      </template>

      <template v-slot:default="props">
        <v-row class="px-4">
          <v-col
            v-for="item in props.items"
            :key="item.membership"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            :xl="xlColWidth"
          >
            <v-card>
              <v-card-title class="subheading font-weight-bold">{{ item.month }}</v-card-title>
              <v-divider></v-divider>
              <v-list dense loading>
                <v-list-item v-for="(key, index) in filteredKeys" :key="index">
                  <v-list-item-content
                    class="font-weight-bold"
                    :class="{ 'accent--text': sortBy === key }"
                    >{{ key }}:</v-list-item-content
                  >
                  <v-list-item-content
                    class="align-end"
                    :class="{ 'accent--text': sortBy === key }"
                    >{{ item[key.toLowerCase()] }}</v-list-item-content
                  >
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-row class="px-7 pt-2 pb-4" align="center" justify="center">
          <v-spacer></v-spacer>
          <span class="mr-4 grey--text">Page {{ page }} of {{ numberOfPages }}</span>
          <v-btn small fab dark color="primary" class="mr-1" @click="formerPage">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn small fab dark color="primary" class="ml-1" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
  <v-row v-else-if="this.insurance.length == 0">
    <v-col class="pt-0 pb-0">
      <v-alert class="mb-0" type="info" :value="true" tile
        >Please select an insurance to continue</v-alert
      >
    </v-col>
  </v-row>
  <v-row v-else-if="(this.loading = true)">
    <v-col class="text-center">
      <v-progress-circular
        indeterminate
        color="secondary"
        :size="50"
        :width="3"
      ></v-progress-circular>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios';

export default {
  name: 'provComp',
  props: [
    'organization',
    'group',
    'groupNum',
    'providers',
    'locations',
    'insurance',
    'startDate',
    'endDate',
    'hideToolbar',
    'runOnMounted',
    'xlColWidth', // needed for provider modal
  ],
  data() {
    return {
      search: '',
      load: true,
      sortDesc: false,
      itemsPerPageArray: [1, 2, 4, 6, 8, 12],
      page: 1,
      pagination: '',
      sortBy: 'Month',
      loading: false,
      keys: [
        'Month',
        'Membership',
        'MLR',
        'MRA',
        'Revenue',
        'Expenses',
        'ER Visits',
        // "ER Per 1000",
        'ER Visits Cost',
        'Admissions',
        'Admissions Cost',
        'Brand Rx Count',
        'Brand Rx Cost',
        // "Readmissions",
        // "Readmissions Cost",
        // "Avg. Cost Per Adm.",
        // "Adm. Per 1000",
        // "Days Per 1000"
      ],
      membership: [],
      headers: [],
      patients: [],
      cancelSource: null,
    };
  },
  created() {
    if (this.runOnMounted) {
      this.getPatients();
    }
  },
  mounted() {},
  computed: {
    // Get pages and key, value pairs
    numberOfPages() {
      return Math.ceil(this.membership.length / this.itemsPerPage);
    },
    filteredKeys() {
      return this.keys.filter(key => key !== 'Month');
    },
    itemsPerPage: {
      get() {
        if (this.$vuetify.breakpoint.xl && this.xlColWidth == 2) {
          return 6;
        }
        if (this.$vuetify.breakpoint.xl && this.xlColWidth != 2) {
          return 4;
        }
        if (this.$vuetify.breakpoint.lgAndUp) {
          return 4;
        }
        if (this.$vuetify.breakpoint.mdAndUp) {
          return 3;
        }
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  methods: {
    // Get  all patients
    async getPatients() {
      this.loading = true;
      const org = this.organization;
      const { group } = this;
      const pro = this.providers;
      const loc = this.locations;
      const ins = this.insurance;
      const start = this.startDate;
      const end = this.endDate;
      let provNum = [];
      let locAddress = [];
      let url;

      // clear report data
      this.membership = [];

      // Add provider numbers for query purposes
      if (pro.length > 0) {
        pro.forEach((prov) => {
          if (provNum.indexOf(prov.Center_PCP_Number) === -1) {
            provNum.push(prov.Center_PCP_Number);
          }
        });
      } else {
        provNum = [];
      }

      // Add location addresses for query purposes
      if (loc.length > 0) {
        loc.forEach((loca) => {
          if (locAddress.indexOf(loca.Center_Location) === -1) {
            locAddress.push(loca.Center_Location);
          }
        });
      } else {
        locAddress = [];
      }

      // set API route
      url = `api/kpi/groups=${this.groupNum}/providers=${provNum}/locs=${locAddress}/${ins}/${start}/${end}`;

      // Check for pending request and if so cancel old one for new incoming
      this.cancelSearch();
      // Set the CancelToken
      this.cancelSource = axios.CancelToken.source();

      const response = axios.get(url, { cancelToken: this.cancelSource.token }).then((response) => {
        // Set cancelsource back to null
        this.cancelSource = null;

        const { data } = response;

        data.forEach((info) => {
          info.mlr = info.mlr ? `${info.mlr}%` : 'No data';
          info.mra = info.mra ? info.mra : 'No data';
          info.revenue = info.revenue ? `$${this.formatCurrency(info.revenue)}` : 'No data';
          info.expenses = info.expenses ? `$${this.formatCurrency(info.expenses)}` : 'No data';
          info['er visits'] = info['er visits'] ? info['er visits'] : 'No data';
          info['er visits cost'] = info['er visits cost']
            ? `$${this.formatCurrency(info['er visits cost'])}`
            : 'No data';
          info.admissions = info.admissions ? info.admissions : 'No data';
          info['admissions cost'] = info['admissions cost']
            ? `$${this.formatCurrency(info['admissions cost'])}`
            : 'No data';
          info['brand rx count'] = info['brand rx count'] ? info['brand rx count'] : 'No data';
          info['brand rx cost'] = info['brand rx cost']
            ? `$${this.formatCurrency(info['brand rx cost'])}`
            : 'No data';
        });

        this.membership = data;
        this.loading = false;
      });
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel('Start new search, stop active search');
      }
    },
    formatCurrency(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    },
  },
  watch: {
    // Watch date inputs
    async startDate(val) {
      this.getPatients();
    },
    endDate(val) {
      this.getPatients();
    },
    async insurance() {
      if (this.insurance.length > 0 && this.group.length === 0) {
        this.getPatients();
      }
    },
    async groupNum() {
      this.getPatients();
    },
    async providers() {
      this.getPatients();
    },
    async locations() {
      this.getPatients();
    },
  },
};
</script>
